import { render, staticRenderFns } from "./faceconfig.vue?vue&type=template&id=4c1afafd"
import script from "./faceconfig.vue?vue&type=script&lang=js"
export * from "./faceconfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports